import { configureStore } from "@reduxjs/toolkit";
import areaReducer from "./slices/areaSlice";

export const store = configureStore({
  reducer: {
    area: areaReducer,
  },
});

export default store;
